import { createActions } from 'redux-actions';

import types from 'state/direct-order-recurring/extras/actionTypes';

const { directOrderRecurring } = createActions({
  [types.SET_EXTRA]: (extra) => ({ extra }),
  [types.SET_EXTRAS]: (extras) => ({ extrasValues: extras }),
});

export default directOrderRecurring;
